<template>
  <div class="the-header-tab">
    <!-- <div
      v-for="(tab, index) in tabs"
      :key="index"
      :class="['item', tab.id === currentTab && 'active']"
      @click="tabClick(tab.id)"
    >
      <span>{{ tab.name }}</span>
    </div> -->
    <el-dropdown class="custom-dropdown" @command="tabClick">
      <div type="primary" size="small" class="active">
        <span>{{ tab.name }}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(tab, index) in tabs" :key="index" :command="tab">
          {{
            tab.name
          }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheHeaderTab',
  data () {
    return {
      tab: {},
      tabs: [],
    }
  },

  computed: {
    ...mapGetters(['currentTab']),
  },

  created () {
    // [1, 2] 哨兵二代 和 瞭望者, 暂时只使用deviceGroup这两个数据
    this.tabs = this.$store.state.deviceGroup
      ? [{ id: null, name: '全部' }, ...this.$store.state.deviceGroup.filter(e => [1, 2].includes(e.id))]
      : []
    if (this.currentTab) {
      let tab = this.tabs.find(e => e.id === this.currentTab)
      if (tab) {
        this.tab = tab
      }
    } else {
      this.tab = this.tabs[0]
    }
  },
  methods: {
    tabClick (tab) {
      this.tab = tab
      this.$store.commit('setCurrentTab', tab.id)
    },
  },
}
</script>

<style lang="less" scoped>
.the-header-tab {
  position: absolute;
  top: 15px;
  left: 60px;
  text-align: center;
  .custom-dropdown {
    box-sizing: border-box;
    display: inline-block;
    height: 30px;
    line-height: 30px;
    cursor: pointer;

    .active {
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      border: none;
      width: 120px;
      // height: 37px;
      background-image: url(/static/img/common/tabSelect.png);

      > span {
        background-image: linear-gradient(#1aa5ff, #46c8ff, #72eaff);
        background-clip: text;
        -webkit-text-fill-color: transparent;
        display: inline-block;
        text-align: center;
      }
    }
  }
}
.el-dropdown-menu {
  width: 120px;
  top: 36px;
  left: 61px;
  border: none;
  background: #0347a4;
  /deep/ .popper__arrow {
    border-width: 0;
  }
  /deep/ .popper__arrow::after {
    border-width: 0;
    margin-right: 0;
    border-top-width: 0;
    border-bottom-color: unset !important;
  }
  .el-dropdown-menu__item {
    color: #fff;
  }
  .el-dropdown-menu__item:hover {
  background: #1aa5ff;
  }
}
</style>
